import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const Wrap = styled.div`
  display: flex;
  gap: 40px;
  height: 100%;
  position: relative;
`
const linkStyle = `
  height: 100%;
  img {
    height: 100%;
  }
`
export const StyledLink = styled(Link)`
  ${linkStyle}
`
export const ExternalLink = styled.a`
  ${linkStyle}
`

export const Logo = styled.div`
  height: 36%;
  position: relative;
  top: 50%;
  margin-top: -10px;
  @media screen and (max-width: ${props => props.theme.resolution.sm}) {
    height: 50%;
    margin-top: -8px;
  }
  img {
    height: 100%;
  }
`
